import HttpService from '@/servises/HttpService';
import { getEndpoint } from '@/utils/endpoints';

export default {
    getCompanies: (params) => {
        return HttpService.get(getEndpoint('companies'), {
            params: params
        });
    }
};
